import React from "react";
import axios from "axios";
import { BASE_URL } from "../../config/constant";
import DataGrid from "components/table/DataGrid";
import { Drawer } from "components/Drawer";
import { UserForm } from "../users/UserForm";
import { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import { getToken } from "../../Service/Service";
import { Container, Tabs, Tab, Box, Paper, CircularProgress, Typography } from "@mui/material";

const Consumer = () => {
  const [allcustomer, setAllCustomer] = React.useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [readonly, setReadOnly] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  React.useEffect(() => {
    fetchConsumer("complete");
  }, []);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    fetchConsumer(newValue === 0 ? "complete" : "pending");
  };

  const reset = useCallback(() => {
    setOpenDrawer(false);
    setEditItem(null);
    setReadOnly(false);
  }, []);

  const fetchConsumer = async (status: string) => {
    setIsLoading(true);
    try {
      const result = await axios.post(
        BASE_URL + "agent/fingerprint",
        {
          findKey: status
        },
        {
          headers: {
            encryption: false,
            token: getToken(),
          },
        }
      );
      if (result.data) {
        setAllCustomer(result.data.data);
        toast.success(result.data.message);
      }
    } catch (error) {
      console.error(error);
      //@ts-ignore
      toast.error(error.response?.data?.message || "Error fetching data");
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    { title: "Main Aadhaar", field: "mainAadhaar" },
    { title: "Family Aadhaar", field: "familyAadhaar" },
    { title: "Mobile", field: "mobile" },
    { title: "Registered Agency", field: "registeredAgencyName" },
    { title: "Main Agent", field: "mainAgent" },
    { title: "Sub Agent", field: "subAgent" },
    { title: "Installation", field: "installtatus" },
    {
      title: "Free Delivery",
      field: "isFreeDelivery",

    },
    {
      title: "Single Women",
      field: "isSingleWomen",

    },
    {
      title: "Registration",
      field: "registrationStatus",
    },
    { title: "Remarks", field: "remarks" }
  ];

  return (
    <Container maxWidth="xl" style={{ marginTop: "6rem" }}>

      <Paper elevation={3} sx={{ mt: 6, borderRadius: 2, overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: '#fff' }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered
            sx={{
              px: 2,
              pt: 2,
              '& .Mui-selected': {
                color: '#1976d2',
                fontWeight: 'bold',
              },
              '& .MuiTabs-indicator': {
                height: 3,
                borderRadius: '3px 3px 0 0'
              }
            }}
          >
            <Tab
              label="Fingerprint Complete"
              sx={{
                color: tabValue === 0 ? '#1976d2' : '#666',
                '&:hover': { color: '#1976d2' }
              }}
            />
            <Tab
              label="Fingerprint Pending"
              sx={{
                color: tabValue === 1 ? '#1976d2' : '#666',
                '&:hover': { color: '#1976d2' }
              }}
            />
          </Tabs>
        </Box>

        <Box sx={{ p: 3, position: 'relative', minHeight: '400px' }}>
          {isLoading ? (
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2
            }}>
              <CircularProgress sx={{ color: '#1976d2' }} />
              <Typography variant="body1" color="textSecondary">
                Loading data...
              </Typography>
            </Box>
          ) : (
            <DataGrid
              title="Jaman HP Gas | Consumer"
              columns={columns}
              rows={allcustomer}
            />
          )}
        </Box>
      </Paper>

      <Drawer
        title="Update Consumer"
        variant="lg"
        anchor="right"
        open={openDrawer}
        onClose={reset}
      >
        <UserForm
          readonly={readonly}
          editData={editItem}
          onParentClose={reset}
        />
      </Drawer>
    </Container>
  );
};

export default Consumer;
